import { JSX } from "react";
import "../../App.scss";
import { appContext } from "../../AppContext";
import { IbssPage } from "../../Components/Core/BasePage/IbssPage";
import { Typography } from "@iconics/components";
import "./Styles.scss";

class AccessDenied extends IbssPage<IProps, IState>
{
    public componentDidMount(): void
    {
        this.pageTitle = appContext().labels.HubLabelaccessDeniedLabel;
    }

    public render(): JSX.Element
    {
        return (
            <div className="content">
                <div className="card">
                    <Typography role="body" size="large">
                        {appContext().labels.HubLabelaccessDenied}
                    </Typography>
                </div>
            </div>
        );
    }
}

export default AccessDenied;
export interface IProps { }
export interface IState { }
